<template>
  <div class="edit__user">
    <v-dialog v-model="value" max-width="800px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-text-field
            class="mt-5"
            v-model="editedItem.famil"
            label="Фамилия"
            :readonly="!edit"
          />
          <v-text-field
            v-model="editedItem.profile_name"
            required
            label="*Имя"
            :readonly="!edit"
          />
          <v-text-field
            v-model="editedItem.otch"
            label="Отчество"
            :readonly="!edit"
          />
          <v-text-field
            v-model="editedItem.position"
            label="Должность"
            :readonly="!edit"
          />
          <v-text-field
            v-model="editedItem.phone"
            label="Телефон"
            :readonly="!edit"
          />
          <v-text-field
            v-model="editedItem.emailContact"
            label="*Логин"
            :readonly="!edit"
          />
          <v-select
            v-model="editedItem.role"
            :items="roles"
            item-text="name"
            item-value="role"
            label="Роль"
            required
            v-if="edit"
          />
          <h4 v-if="!edit && roles && roles.length">{{ getRoleName() }}</h4>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="close">Закрыть</v-btn>
          <v-btn
            @click="deleteItem(editedItem.user_id)"
            dark
            color="red"
            v-if="edit"
            >Удалить</v-btn
          >
          <v-btn dark color="success" @click="save" v-if="edit"
            >Сохранить</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "add__user",
  components: {},
  props: {
    value: { type: Boolean, default: false },
    editedItem: {
      famil: { type: String, default: "" },
      name: { type: String, default: "" },
      otch: { type: String, default: "" },
      position: { type: String, default: "" },
      phone: { type: String, default: "" },
      phone_note: { type: String, default: "" },
      emailContact: { type: String, default: "" },
      role: { type: String, default: "" },
    },
    title: { type: String, default: "Редактировать запись" },
    edit: { type: Boolean, default: true },
    // editedIndex: { type: Number },
  },
  data: () => ({
    defaultItem: {
      famil: "",
      name: "",
      otch: "",
      position: "",
      phone: "",
      phone_note: "",
      email: "",
      role: "",
    },
  }),
  methods: {
    getRoleName() {
      const roles = this.getRoles();
      const role = this.editedItem.role;
      const find =
        roles && roles.length
          ? roles.filter((item) => (item.role === role ? true : false))
          : undefined;
      return find && find.length ? find[0].name : this.editedItem.role;
    },
    deleteItem(id) {
      this.$store.dispatch("deleteAgentSorts", id).then(() => {
        this.items = this.$store.getters.getAgentFirmSorts;
        if (this.$store.getters.getErrorApi == "DELETEYOURSELF") {
          Swal.fire({
            icon: "warning",
            title: "Ошибка удаления",
            text: "Нельзя удалить самого себя.",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Удалено",
            text: "Удаление прошло успешно",
          });
          this.close();
        }
      });
    },
    close() {
      this.$emit("close", true);
    },
    makeGoodField(val) {
      if (!val) return "";
      else return val;
    },
    save() {
      var data;

      if (!this.editedItem.profile_name) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Поле 'Имя' обязательно к заполнению ",
        });
        return;
      }
      if (!this.editedItem.emailContact) {
        Swal.fire({
          icon: "error",
          title: "Ошибка",
          text: "Поле 'Контактный Email' обязательно к заполнению ",
        });
        return;
      }

      // if (this.editedIndex > -1) {
      data = {
        id: this.editedItem.user_id,
        famil: this.makeGoodField(this.editedItem.famil),
        name: this.makeGoodField(this.editedItem.profile_name),
        otch: this.makeGoodField(this.editedItem.otch),
        position: this.makeGoodField(this.editedItem.position),
        phone: this.makeGoodField(this.editedItem.phone),
        phone_note: this.makeGoodField(this.editedItem.phone_note),
        emailContact: this.editedItem.emailContact,
        role: this.editedItem.role,
      };

      this.$store.dispatch("updateAgentSorts", data).then(() => {
        this.items = this.$store.getters.getAgentFirmSorts;
        if (this.$store.getters.getErrorApi == "ADMINFOREVER") {
          Swal.fire({
            icon: "warning",
            title: "Роль не изменилась",
            text: "Нельзя лишить себя роли администратора.",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "удачно!",
            text: "Данные сотрудника обновлены",
          });
        }
      });
      // } else {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Рано!",
      //     text: "Добавлялка не выросла",
      //   });
      // }
      this.close();
    },
  },
  computed: {
    roles() {
      return this.getRoles();
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
